/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback } from "react";
import Routes from "./Routes";
// import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import * as AuthAPI from "./offline-auth/auth";
import { createTheme } from "@material-ui/core/styles";
import { Provider } from "react-redux";
// import P2P from './containers/conference/libs/P2P';
import InstaSignaler from "./containers/conference/libs/InstaSignaler";
import VoiceCommandProcess from "./containers/conference/libs/VoiceCommandProcess";
import "./App.css";
import { config } from "./config";
// import {lang} from `./locale/lang-${config.lang}.json`;Scroll issue in Authentication pages of inclass
import { languageObj } from "./locale/index";
import {
  LanguageContext,
  roleContext,
  LicenseContext,
  PayloadContext,
  DomainContext,
} from "./libs/context";
import { OffLineAPI } from "./offline-auth/api";
import { ToastContainer } from "react-toastify";
import { useHistory } from "react-router";
import { getMyLicense, getDomainDeatils } from "./containers/actions/license";
import FullPageLoader from "./containers/fullPageLoader";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import Amplify, { API, Auth } from "aws-amplify";
import { getLicense } from "./containers/actions/license";

const axios = require("axios");
const parseDomain = require("parse-domain");
const _API = config.isOffline ? OffLineAPI : API;
const _Auth = config.isOffline ? AuthAPI.Auth : Auth;

const theme = createTheme({
  palette: {
    primary: { main: "#00B8E2" },
    secondary: {
      main: "#ff9200",
      contrastText: "#fff",
      dark: "#c67100",
    },
  },
  typography: {
    useNextVariants: true,
  },
  overrides: {
    button: {
      borderRadius: "4px",
      color: "#ffffff",
    },
    MuiButton: {
      containedPrimary: {
        backgroundColor: "#00B8E2",
        color: "#ffffff",
      },
    },
    MuiPickersToolbarText: {
      toolbarBtnSelected: {
        color: "#fff",
      },
      toolbarTxt: {
        color: "#fff",
      },
    },
    MuiPickerDTTabs: {
      tabs: {
        color: "#fff",
      },
    },
    MuiPickersDay: {
      daySelected: {
        color: "#fff",
      },
    },
    MuiPickersClockNumber: {
      clockNumberSelected: {
        color: "#fff",
      },
    },
  },
});

const App = (props) => {
  const history = useHistory();
  const location = useLocation();
  const [language, setLanguage] = useState({
    value: languageObj["en"].locale,
    locale: "en",
  });
  const [license, setLicenses] = useState(null);
  // const [clientConfig, setConfig] = useState({ logo: undefined, subDomain: '', whiteLable: false });
  const [init, setInit] = useState({
    isAuthenticated: undefined,
    isPlanManager: undefined,
    userId: null,
    userPayload: null,
  });

  // const [mounted, setMounted] = useState(false)
  const [loading, setLoading] = useState(true);

  const onVCCall = useRef(false);

  const instaSignaler = useRef(new InstaSignaler());
  const vcCommand = useRef(new VoiceCommandProcess());

  const [domainData, setdomainData] = useState({
    subDomain: config.domain,
    logo__url: config.domainLogo,
    whiteLable: false,
  });

  useEffect(async () => {
    let lang = localStorage.getItem("setLang") || "en";
    // setMounted(true);
    setLanguage({
      value:
        languageObj[lang] && languageObj[lang].locale
          ? languageObj[lang].locale
          : languageObj["en"].locale,
      locale: lang,
    });

    if (config.isOfflineMCU) {
      await userHasAuthenticated(false, null);
    }
    try {
      let mySession = null
      await _API.get("user", `/user`)
      .then(async(res) => {
        if (res.status) {
           mySession = await _Auth.currentSession();
        } else {
          localStorage.removeItem("sub")
          localStorage.removeItem("token")
        }
      }).catch((error => {
        localStorage.removeItem("sub")
        localStorage.removeItem("token")
      }))
      // const mySession = await _Auth.currentSession();
      const sub = localStorage.getItem('sub')
      console.log("subDetailsInAppJS", sub)
      await userHasAuthenticated(true, mySession);
    } catch (e) {
      console.log("error in app did mount === ", e);
      await userHasAuthenticated(false, null);
      if (e !== "No current user" && !config.isOfflineMCU) {
        // alert(e);
        console.log("error in userHasAuthenticated======", e);
      }
    }
  }, []);


  const getUserPayload = async () => {
    setLoading(true);
    await _API.get("user", `/user`)
      .then((res) => {
        if (res.status) {
          // console.log("app.js coupon code--------------");
          setInit({
            isAuthenticated: true,
            userId: res.data._id,
            userPayload: res.data,
          });
        } else {
          setInit({
            isAuthenticated: false,
            userId: null,
            userPayload: null,
          });
        }
      })
      .catch((err) => {
        setInit({
          isAuthenticated: false,
          userId: null,
          userPayload: null,
        });
      });
    setLoading(false);
  };


  const userHasAuthenticated = useCallback(
    async (authenticated, session = null) => {
      // console.log("im in user auth", authenticated)
      setLoading(true);
      try {
        const payLoad = await _Auth.currentUserInfo();
        // console.log("app.js--------", payLoad);
        if (authenticated && payLoad) {
          getUserPayload();
        } else {
          localStorage.removeItem("role");
          localStorage.removeItem("userId");
          setInit({
            isAuthenticated: false,
            userId: null,
            userPayload: null,
          });
        }
      } catch (error) {
        console.log("error === ", error);
        localStorage.removeItem("role");
        localStorage.removeItem("userId");
        setInit({
          isAuthenticated: false,
          userId: null,
          userPayload: null,
        });
      }
      setLoading(false);
    },
    []
  );

  const isVCCall = (status) => {
    onVCCall.current = status;
  };

  const VCCallStatus = () => {
    return onVCCall.current;
  };

  const updateLanguage = (lang) => {
    let _lang = localStorage.getItem("setLang");
    if (_lang !== lang) {
      localStorage.setItem("setLang", lang);
      setLanguage({
        value:
          languageObj[lang] && languageObj[lang].locale
            ? languageObj[lang].locale
            : languageObj["en"].locale,
        setLang: lang,
      });
    }
  };

  const getDomain = () => {
    const _subDomain = parseDomain(window.location.hostname);
    if (!loading) {
      if (_subDomain && _subDomain.subdomain) {
        setLoading(true);
        getDomainDeatils(_subDomain.subdomain)
          .then((res) => {
            if (res.data) {
              setdomainData((prevState) => ({
                ...prevState,
                subDomain: res.data?.subdomain,
                logo__url: res.data?.logo_url?.path
                  ? res.data.logo_url.path
                  : "/images/logos/inclass-new.png",
                // poolId: res.data?.poolId
                //   ? res.data.poolId
                //   : config.cognito.USER_POOL_ID,
                // identityPoolId: res.data?.identityId
                //   ? res.data.identityId
                //   : config.cognito.IDENTITY_POOL_ID,
                // appClientId: res.data?.appClientId
                //   ? res.data.appClientId
                //   : config.cognito.APP_CLIENT_ID,
                whiteLable: false,
              }));
              setLoading(false);
            } else {
              window.location.href = "https://app.inclass.vc/sitenotreached";
              setLoading(false);
            }
          })
          .catch((err) => {
            console.log("error========", err);
            window.location.href = "https://app.inclass.vc/sitenotreached";
            setLoading(false);
          });
      }
    }
  };

  const childProps = {
    isAuthenticated: init.isAuthenticated,
    USD: undefined,
    isAffiliate: false,
    isPlanManager: false,
    userHasAuthenticated: userHasAuthenticated,
    instaSignaler: instaSignaler.current,
    vcCommand: vcCommand.current,
    isVCCall: isVCCall,
    VCCallStatus: VCCallStatus,
    userId: init.userId,
    onP2PCall: false,
    webLogo: domainData.logo__url,
    whiteLable: domainData.whiteLable,
    language: language.value,
    setLanguage: updateLanguage,
    setLang: language.locale || "en",
    subDomain: domainData.subDomain,
  };

  return (
    <Provider store={props.store}>
      <MuiThemeProvider theme={theme}>
        <LanguageContext.Provider
          value={language.value}
          locale={language.locale}
        >
          <PayloadContext.Provider
            value={{
              payload: init.userPayload,
              setUserPayload: getUserPayload,
            }}
          >
            <DomainContext.Provider
              value={{
                domain: domainData,
                setDomain: getDomain,
              }}
            >
              <roleContext.Provider
                value={
                  init && init.userPayload && init.userPayload.role
                    ? init.userPayload.role
                    : null
                }
              >
                <LicenseContext.Provider
                  value={{
                    license: license,
                    setLicenses: setLicenses,
                  }}
                >
                  <div className="app">
                    {domainData.logo__url && language.value && (
                      <Routes childProps={childProps} />
                    )}
                  </div>
                  <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                  />
                  {loading && <FullPageLoader />}
                </LicenseContext.Provider>
              </roleContext.Provider>
            </DomainContext.Provider>
          </PayloadContext.Provider>
        </LanguageContext.Provider>
      </MuiThemeProvider>
    </Provider>
  );
};

export default App;
